import { type FC } from 'react';
import { Trans } from 'react-i18next';

import { TranslationEntries } from '@service-initiation/tech-care-data-access-i18n';
import {
  PrivacyPolicyLink,
  TermsOfServiceLink,
} from '@service-initiation/tech-care-ui-legal-links';

const TEXT =
  TranslationEntries.Repairs.CustomerDetails.Form.TermsAndConditionsLabel;

export const TermsAndConditionsText: FC = () => (
  <Trans
    components={{
      AsurionUIPrivacyPolicyLink: <PrivacyPolicyLink />,
      AsurionUITermsOfServiceLink: <TermsOfServiceLink />,
    }}
    i18nKey={TEXT}
  />
);
